import Gallery from 'react-grid-gallery'
import PropTypes from 'prop-types'
import React from 'react'
import shuffleArray from 'shuffle-array'

class PhotosGardenPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            images: this.props.images
        }
    }

    render() {
        return (
          <div className='photoGalleries'>
            <h2>Photo Gallery - 中庭</h2>
            <ul className="breadcrumb">
              <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
                <a href="/" itemProp="url">
                  <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
                </a>
              </li>
              <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
                <span itemProp="title"> <i className="fas fa-caret-right"></i> <i className="fas fa-images"></i> Photo Gallery - 中庭</span>
              </li>
            </ul>
            <div style={{
                display: "block",
                minHeight: "1px",
                width: "100%",
                border: "1px solid #ddd",
                overflow: "auto",
                textAlign: "center",
                background: "white"
            }}>
              <Gallery
                  images={this.state.images}
                  enableImageSelection={false}
              />
            </div>
          </div>
        )
    }
}

PhotosGardenPage.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            srcset: PropTypes.array,
            caption: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element
            ]),
            thumbnailWidth: PropTypes.number.isRequired,
            thumbnailHeight: PropTypes.number.isRequired,
            isSelected: PropTypes.bool
        })
    ).isRequired
}

PhotosGardenPage.defaultProps = {
    images: shuffleArray([
        {
            src: "https://sharehome.biz/images/garden01.jpg",
            thumbnail: "https://sharehome.biz/images/garden01.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "支柱を立てるために水引を張り、水平になるように調整",
            thumbnailCaption: "支柱を立てるために水引を張り、水平になるように調整"
        },
        {
            src: "https://sharehome.biz/images/garden02.jpg",
            thumbnail: "https://sharehome.biz/images/garden02.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "アンティークな窓を購入",
            thumbnailCaption: "アンティークな窓を購入"
        },
        {
            src: "https://sharehome.biz/images/garden03.jpg",
            thumbnail: "https://sharehome.biz/images/garden03.jpg",
            thumbnailWidth: 240,
            thumbnailHeight: 320,
            caption: "支柱を立てました",
            thumbnailCaption: "支柱を立てました"
        },
        {
            src: "https://sharehome.biz/images/garden04.jpg",
            thumbnail: "https://sharehome.biz/images/garden04.jpg",
            thumbnailWidth: 240,
            thumbnailHeight: 320,
            caption: "支柱の傾きや歪みを調整",
            thumbnailCaption: "支柱の傾きや歪みを調整"
        },
        {
            src: "https://sharehome.biz/images/garden05.jpg",
            thumbnail: "https://sharehome.biz/images/garden05.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "支柱の固定具を追加し補強",
            thumbnailCaption: "支柱の固定具を追加し補強"
        },
        {
            src: "https://sharehome.biz/images/garden06.jpg",
            thumbnail: "https://sharehome.biz/images/garden06.jpg",
            thumbnailWidth: 240,
            thumbnailHeight: 320,
            caption: "ドアと窓を設置",
            thumbnailCaption: (<span style={{color: "darkred"}}>ドアと窓を設置 - <i>開閉可能です</i></span>)
        },
        {
            src: "https://sharehome.biz/images/garden07.jpg",
            thumbnail: "https://sharehome.biz/images/garden07.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "ドアと窓の周辺に塀を追加",
            thumbnailCaption: "ドアと窓の周辺に塀を追加"
        },
        {
            src: "https://sharehome.biz/images/garden08.jpg",
            thumbnail: "https://sharehome.biz/images/garden08.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "中庭は一部レンガ敷きに",
            thumbnailCaption: "中庭は一部レンガ敷きに"
        },
        {
            src: "https://sharehome.biz/images/garden09.jpg",
            thumbnail: "https://sharehome.biz/images/garden09.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "ハーブ、お花、食用植物に囲まれる",
            thumbnailCaption: "ハーブ、お花、食用植物に囲まれる"
        },
        {
            src: "https://sharehome.biz/images/garden10.jpg",
            thumbnail: "https://sharehome.biz/images/garden10.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "金柑、山葡萄、フサスグリ、ローズベリー、大蒜、ニラを植えました",
            thumbnailCaption: "金柑、山葡萄、フサスグリ、ローズベリー、大蒜、ニラを植えました"
        },
        {
            src: "https://sharehome.biz/images/garden11.jpg",
            thumbnail: "https://sharehome.biz/images/garden11.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "アンティーク調のテーブルと椅子を設置",
            thumbnailCaption: "アンティーク調のテーブルと椅子を設置"
        },
        {
            src: "https://sharehome.biz/images/garden12.jpg",
            thumbnail: "https://sharehome.biz/images/garden12.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "夜のライトアップされた様子",
            thumbnailCaption: "夜のライトアップされた様子"
        }
    ])
}

export default PhotosGardenPage


// WEBPACK FOOTER //
// ./src/PhotosGardenPage.js